import {useProductVariables} from "./useProductVariables";
import {useSuspenseQuery} from "@apollo/client";
import {contentService} from "../api/contentService";
import {useEffect, useMemo} from "react";
import {ComparisonTableResponseModel} from "../models/view/comparisonTableResponseModel";

export const useComparisonTableQuery = () => {
    const {variables: {productId, currencyCode}} = useProductVariables();

    const {data} = useSuspenseQuery(contentService.product.comparisonTable, {
        variables: {
            productId,
            currencyCode
        }
    });

    const model = useMemo(() => new ComparisonTableResponseModel(data.product), [data?.product]);

    return {model}
}